module.exports = __webpack_public_path__ + "static/img/cont32_06.e06ccfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_06.jpg
// module id = nbUO
// module chunks = 0